import CotizarInformacionProvider from "../providers/cotizarInformacion-provider";
import TokenProvider from "../../commons/providers/token-provider";

class CotizarInformacionRepository {
    
    constructor() {
        this.cotizarInformacionProvider = new CotizarInformacionProvider();
        this.tokenProvider = new TokenProvider();
    }

    postCotizarSimulacion = async (datosConsulta) => {
        await this.tokenProvider.getToken();
        return this.cotizarInformacionProvider.postCotizarSimulacion(datosConsulta);
    }

}

export default CotizarInformacionRepository;